var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Bold_Play",
    "data-name": "Iconly/Bold/Play",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.18,
    height: 65.18,
    viewBox: "0 0 65.18 65.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Play",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76261",
    "data-name": "Path 76261",
    d: "M32.59,0A32.59,32.59,0,1,1,0,32.609,32.637,32.637,0,0,1,32.59,0ZM28.878,19.652a4.377,4.377,0,0,0-1.982.472,4.078,4.078,0,0,0-1.762,1.949,21.023,21.023,0,0,0-.566,2.3,50.263,50.263,0,0,0-.535,8.207,58.16,58.16,0,0,0,.472,7.955,17.818,17.818,0,0,0,.755,2.861,3.96,3.96,0,0,0,3.492,2.138h.126a10.947,10.947,0,0,0,2.926-.88c3.335-1.384,9.909-5.691,12.551-8.553h0l.189-.189a12.956,12.956,0,0,0,.881-1.006,3.786,3.786,0,0,0,.755-2.292,3.972,3.972,0,0,0-.818-2.456c-.126-.126-.6-.66-1.038-1.1a48.094,48.094,0,0,0-12.835-8.678A10.706,10.706,0,0,0,28.878,19.652Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayLg);
export default __webpack_public_path__ + "static/media/play_lg.7e6c42a3578e6aee4755977489d2660a.svg";
export { ForwardRef as ReactComponent };